import { AUTH_PERSISTENT_KEYS } from '~/constants/auth-persistent.constant'

// composables/useAuth.ts
interface LandingUser {
  fullName: string
  email: string
  status: string
  [key: string]: any
}

const token = ref<string | null>(null)
const user = ref<LandingUser | null>(null)

function initAuth() {
  if (typeof window === 'undefined') return

  const storedToken = localStorage.getItem(AUTH_PERSISTENT_KEYS.TOKEN)
  const storedUser = localStorage.getItem(AUTH_PERSISTENT_KEYS.USER)

  if (storedToken) token.value = storedToken

  if (storedUser) {
    try {
      user.value = JSON.parse(storedUser)
    } catch {
      user.value = null
    }
  }
}

export function useAuth() {
  onMounted(() => {
    initAuth()
  })

  const isLoggedIn = computed(() => !!token.value)

  return { token, user, isLoggedIn }
}
